import { render, staticRenderFns } from "./SwitchTabs.vue?vue&type=template&id=380e448d&scoped=true"
import script from "./SwitchTabs.vue?vue&type=script&lang=js"
export * from "./SwitchTabs.vue?vue&type=script&lang=js"
import style0 from "./SwitchTabs.vue?vue&type=style&index=0&id=380e448d&prod&scoped=true&lang=css"
import style1 from "./SwitchTabs.vue?vue&type=style&index=1&id=380e448d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380e448d",
  null
  
)

export default component.exports